var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-aside",
    { attrs: { width: _vm.asideWidth } },
    [
      _c(
        "el-menu",
        {
          class: { "el-menu-side-nav": true, collapsed: _vm.collapsed },
          attrs: {
            collapse: _vm.collapsed,
            "collapse-transition": false,
            router: true
          },
          on: {
            select: function($event) {
              _vm.collapseMenuIfMobile()
            }
          }
        },
        [
          _vm.hasRoleToReadClubs
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/club"),
                  attrs: {
                    index: "/entities/club",
                    route: { name: "clubList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_club"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.club.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadTeams
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/team"),
                  attrs: {
                    index: "/entities/team",
                    route: { name: "teamList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_team"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.team.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadCategories
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/category"),
                  attrs: {
                    index: "/entities/category",
                    route: { name: "categoryList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_category"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.category.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadPositions
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/position"),
                  attrs: {
                    index: "/entities/position",
                    route: { name: "positionList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-text" }, [_vm._v("P")]),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.position.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadDocuments
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/document"),
                  attrs: {
                    index: "/entities/document",
                    route: { name: "documentList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.document.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadTournament
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/tournament"),
                  attrs: {
                    index: "/entities/tournament",
                    route: { name: "tournamentList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-text" }, [_vm._v("T")]),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.tournament.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadPlayers ||
          _vm.hasRoleToReadManagers ||
          _vm.hasRoleToReadCoaches
            ? _c(
                "el-menu-item-group",
                { attrs: { title: _vm.$t("entities.user.plural") } },
                [
                  _vm.hasRoleToReadUsers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/user"),
                          attrs: {
                            index: "/user",
                            route: {
                              name: "userList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.user.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadPlayers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/player"),
                          attrs: {
                            index: "/entities/player",
                            route: {
                              name: "playerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c(
                            "i",
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "menu-icon",
                                  "icon-class": "ic_player"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.player.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadManagers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/manager"),
                          attrs: {
                            index: "/entities/manager",
                            route: {
                              name: "managerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.manager.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadTeamManagers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/teamManager"),
                          attrs: {
                            index: "/entities/kteamManager",
                            route: {
                              name: "teamManagerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("entities.teamManager.plural")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadCoaches
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/coach"),
                          attrs: {
                            index: "/entities/coach",
                            route: {
                              name: "coachList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.coach.plural")))]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("version-app")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff739f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff739f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/layout/menu.vue
// module id = null
// module chunks = 